import Vue from 'vue';

export class Banco {

    /**
     *
     * @returns {Promise}
     */
    static combo(){
        return new Promise((resolve, reject) => {
            Vue.http.get('bancos/all/combo')
                .then((res) => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    /**
     *
     * @returns {Promise}
     */
    static byPK(id){
        return new Promise((resolve, reject) => {
            Vue.http.get('bancos/' + id)
                .then((res) => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    static save (json) {
        if (json.id) {
            return Banco.update(json.id, json);
        } else {
            return Banco.insert(json);
        }
    }

    /**
     *
     * @returns {Promise}
     */
    static update(id, json){
        return new Promise((resolve, reject) => {
            Vue.http.put('bancos/' + id, json)
                .then((res) => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

    /**
     *
     * @returns {Promise}
     */
    static insert(json){
        return new Promise((resolve, reject) => {
            Vue.http.post('bancos', json)
                .then((res) => resolve(res.data))
                .catch((err) => reject(err));
        });
    }

}
